"use client";

import { useHydrateAtoms } from "jotai/utils";
import { type ReactNode } from "react";

import { optionchainAtom } from "#/store/options/page/optionchain";
import { type OptionChainEntry } from "#/types/options";

interface GlobalHydratorProps {
  children: ReactNode;
  optionchain: OptionChainEntry[];
}

export const GlobalHydrator: React.FC<GlobalHydratorProps> = ({
  children,
  optionchain,
}) => {
  useHydrateAtoms([[optionchainAtom, optionchain]]);
  return children;
};
